<template>
    <div class="form-group">
        <label :for="identifier" v-if="label">{{ label }} {{ requiredAsterisk }}</label>
        <select
            class="form-control"
            :id="identifier"
            :name="name"
            :value="fieldValue"
            @change="updateValue($event.target.value)"
            v-bind="attributes"
            :class="{'is-invalid': valid === false}"
            :aria-invalid="!valid"
            :aria-describedby="identifierError"
        >
            <slot />
        </select>
        <div :id="identifierError" class="invalid-tooltip" v-html="errorMessages" />
    </div>
</template>

<script>
import FormField from "@/mixins/FormField";

export default {
    name: "SelectInput",
    mixins: [FormField],
    inheritAttrs: false,
}
</script>
